import React from 'react';
import styles from '../../DataExtractionTemplate.module.scss';
import InterventionsFields from './InterventionsFields';
import CharacteristicsFields from './CharacteristicsFields';
import {
  Heading,
  Popover,
  Text,
  PopoverTrigger,
  PopoverContent,
} from 'components/core';

interface Props {
  hasExtractedData?: boolean;
}

const InterventionsMainContent = ({ hasExtractedData = false }: Props) => {
  return (
    <>
      <Heading type="h5" component="h4" variant="neutral">
        Interventions
      </Heading>
      <Popover closeOnBlur={true} renderCloseButton={false}>
        <Text>
          During extraction, you can{' '}
          <PopoverTrigger>
            <Text component="span" className={styles.PopoverTrigger}>
              select and customise
            </Text>
          </PopoverTrigger>{' '}
          interventions for each study.
        </Text>
        <PopoverContent className={styles.PopoverContentText}>
          <Text>
            You only need to extract data for interventions that are relevant to
            each study.
          </Text>
          <Text>
            When extracting, you can also create multiple groups associated with
            each intervention. This is useful when there are multiple study
            groups reported or if you want to create subgroups for a subgroup
            analysis.
          </Text>
        </PopoverContent>
      </Popover>

      <InterventionsFields hasExtractedData={hasExtractedData} />

      <div className={styles.details} data-testid="characteristics">
        <Heading type="h5" component="h4" variant="neutral">
          Characteristics
        </Heading>
        <Popover closeOnBlur={true} renderCloseButton={false}>
          <Text>
            Define{' '}
            <PopoverTrigger>
              <Text component="span" className={styles.PopoverTrigger}>
                characteristics
              </Text>
            </PopoverTrigger>{' '}
            you want to collect for each intervention.
          </Text>
          <PopoverContent className={styles.PopoverContentText}>
            <Text>
              During extraction, a table will be created with a row for each
              characteristic and a column for each group reported in the study.
            </Text>
            <Text>
              Collecting this data will allow you to compare the differences
              between interventions.
            </Text>
            <Text>
              <strong>For example</strong>: Description of the treatment /
              exposure
            </Text>
          </PopoverContent>
        </Popover>

        <CharacteristicsFields hasExtractedData={hasExtractedData} />
      </div>
    </>
  );
};

export default InterventionsMainContent;
